import { routes as fornecedor } from './fornecedor';
import { routes as unidadegrupo } from './unidade-grupo';
import { routes as regional } from './regional';
import { routes as obra } from './obra';
import { routes as documento } from './documento';
import { routes as classificacao } from './classificacao';
import { routes as registrofotografico } from './registro-fotografico';
import { routes as centroCusto } from './centro-custo';
import { routes as proprojetista } from './proprojetista';
import { routes as pendenciasLancamento } from './pendencias-lancamento';
import { routes as tipoFornecimento } from './tipo-fornecimento';

export default [
  {
    path: '/gestao',
    name: 'Gestao',
    description: 'Gestão',
    icon: 'uil-user-hard-hat',
    children: [
      ...fornecedor,
      ...unidadegrupo,
      ...regional,
      ...classificacao,
      ...obra,
      ...documento,
      ...registrofotografico,
      ...centroCusto,
      ...pendenciasLancamento,
      ...proprojetista,
      ...tipoFornecimento
    ]
  }
];
